import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import unregister from './registerServiceWorker';
import Itch from './ItchApi'

ReactDOM.render(<App />, document.getElementById('root'));

Itch.attachBuyButton(document.getElementById("buy_button"), {
  // replace the following with the correct information about your game
  user: "ltjax",
  game: "abstractanks"
});

unregister();



// WEBPACK FOOTER //
// ./src/index.js